import { get, map } from 'lodash';

import Model from 'models';

const PageSectionStatementTextModule = class extends Model {
  get body() {
    return get(this, ['_data', 'body']);
  }

  get ctaLinks() {
    const data = get(this._data, 'ctaLinks');

    return map(data, link => ({
      linkUrl: get(link, 'url'),
      label: get(link, 'text'),
    }));
  }

  get internalName() {
    return get(this, ['_data', 'internalName']);
  }

  get title() {
    return get(this, ['_data', 'title']);
  }

  get type() {
    return get(this, ['_data', '_contentType']);
  }
};

export default PageSectionStatementTextModule;
